// StarRocks publishes a profile up to ~2 s after the query; one retry at 2 s raced it.
export const QUERY_STATS_RETRY_DELAYS_MS = [0, 1500, 1500, 2000, 3000, 4000] as const;
export const QUERY_STATS_BYTES_PER_UNIT = 1024;
export const QUERY_STATS_BYTE_UNITS = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB'] as const;
/** Lines of executed SQL shown before the "show full query" toggle. */
export const QUERY_SQL_PREVIEW_LINES = 40;
/** A finished query's profile never changes; the FE evicts it long before this. */
export const QUERY_ANALYSIS_MAX_AGE_MS = 30 * 60_000;
